export const GRACE_PERIOD_IN_SECONDS_COMPLETION_DATE = 60;
export const TABLE_VIEW_BUTTONS_TEST_ID = 'table-view-buttons';
